import { Alert, Button, Dialog, DialogContent } from "@mui/material";
import Cookies from "js-cookie";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Outlet, useLocation, useNavigate } from "react-router-dom";


const ProtectPlanRoutes = (ActualRoute) => {
    const {t, i18n} = useTranslation();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const {questionlist} = location.state || {}
    const questionList_id = queryParams.get('questionList_id') !== "" ? queryParams.get('questionList_id') : "";
    const navigate = useNavigate();
    const LicenceType = parseInt(Cookies.get("plan"));
    const Length = parseInt(localStorage.getItem("coursesLength"));
    const organization = parseInt(Cookies.get("organization"));
    const single = parseInt(localStorage.getItem('singleCourses'));
    const journey = parseInt(localStorage.getItem('journeyCourses'));
    const total = single+journey;
    const [dialog, setDialog] = useState(true)
    let error = false;
        if (organization !== 1) {
        if (!questionList_id) {
            if (LicenceType === 0 && total >= 2) {
                error = true;
            }else if (LicenceType === 1 && total >= 3) {
                error = true;
            }else if (LicenceType === 2 && total >= 13) {
                error = true;
            }else if (LicenceType === 3 && total >= 25) {
                error = true;
            }
        }
    }
    const handleDialogClose = () => {
        setDialog(false);
        GoDashboard();
    }
    const GoDashboard = () => {
        if (questionlist) {
            navigate('/Dashboard/questionList');
            sessionStorage.setItem("tab",2);
        }else{
            navigate('/Dashboard');
            sessionStorage.setItem("tab",LicenceType===3 ?11:4);
        }
    }
    
    return( <div>{error ? <Dialog open={dialog} onClose={handleDialogClose}>
        <DialogContent>
            <Alert severity="error">{t('Settings.CantAccess')}</Alert>
            <div className="flex justify-center mt-3">
                {/* <Button><TryFree CloseResp={handleDialogClose}/>Free</Button> */}
                <Button onClick={()=>{navigate('/Dashboard/settings', {state : {fireUpDialog: true}});setDialog(false)}}><p>{t('Settings.Upgrade')}</p></Button>
                <Button onClick={GoDashboard}><p>{questionlist ?t('Settings.GoQuestionLists') : t('Settings.GoDashboard')}</p></Button>
            </div>
        </DialogContent>
    </Dialog>  : <Outlet/>}</div>);
};
export default ProtectPlanRoutes;